import React from 'react';
export function StarFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__b899e__clip0)"
  }, React.createElement("path", {
    d: "M12.936.649a1 1 0 00-1.872 0L8.307 8H1a1 1 0 00-.707 1.707l5.545 5.545-2.774 7.397a1 1 0 001.426 1.223L12 19.647l7.51 4.225a1 1 0 001.426-1.223l-2.774-7.397 5.545-5.545A1 1 0 0023 8h-7.307L12.936.649z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__b899e__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}